import { render, staticRenderFns } from "./FilesRequestTable.vue?vue&type=template&id=f18e139e&scoped=true"
import script from "./FilesRequestTable.vue?vue&type=script&lang=js"
export * from "./FilesRequestTable.vue?vue&type=script&lang=js"
import style0 from "./FilesRequestTable.vue?vue&type=style&index=0&id=f18e139e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f18e139e",
  null
  
)

export default component.exports